import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/material';

const theme = createTheme();

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: '32px',
    width: '100%',
    opacity: 0.9,
    margin: 'auto',
    justifyContent: 'center',
  },
}));

interface CopyrightProps {
  className?: string;
  mensaje?: string;
  entidad?: string;
  urlEntidad?: string;
  anioLanzamiento?: number;
  [key: string]: any;
}

/**
 * Para ser usado como pie de página de la web de cualquier entidad con mensaje, link y año autoactualizable.
 *
 * Cualquier otra propiedad no especificada en la documentación será reenviada al elemento html `div`.
 */
function Copyright({
  className,
  mensaje,
  entidad,
  urlEntidad = '#',
  anioLanzamiento,
  ...rest
}: CopyrightProps) {
  const { classes, cx } = useStyles();
  const anioActual = new Date().getFullYear();

  return (
    <Container {...rest} className={cx(classes.root, className)}>
      <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
        {mensaje}
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        {' © '}
        {anioLanzamiento && anioLanzamiento != anioActual
          ? `${anioLanzamiento}-${anioActual}`
          : anioActual}{' '}
        <Link component="a" target="_blank" href={urlEntidad}>
          {entidad}.
        </Link>{' '}
        Todos los derechos reservados.
      </Typography>
    </Container>
  );
}

export default Copyright;
